module.exports = __webpack_public_path__ + "img/lazada.bb7f4c6.svg";